<template>
  <div class="fertilizer">
    <div class="box">Shush, I'm making no sense.</div>
    <div class="updated">27 XI 2007</div>
  </div>
</template>

<script>
export default {
  name: "shush"
};
</script>

<style scoped>
.fertilizer {
  background-color: #486090;
}

.box {
  font: 4em Lucida Sans, Helvetica, Arial;
  letter-spacing: -0.07em;
  margin-top: -50px;
}

.box,
.updated {
  color: #d8d890;
}
</style>
